import { action } from '@ember/object';
import { service } from '@ember/service';
import Component from '@glimmer/component';
import textDeltaIsEmpty from 'scaleflow/utils/text-delta-is-empty';

export default class InitiativesPopoverListItemIndexComponent extends Component {
  @service confetti;

  @action
  toggleCheckbox() {
    if (!this.args.item.completed) {
      this.confetti.play();
    }
  }

  @action
  showInvalidAnimation() {
    const element = document.querySelector('#new-remark-container');
    element.classList.add('wiggle-box');
    setTimeout(() => {
      element.classList.remove('wiggle-box');
    }, 300);
  }

  @action
  saveItem() {
    if (this.args.item.isSaving) return;
    if (textDeltaIsEmpty(this.args.item.text_delta)) {
      this.showInvalidAnimation();
      return;
    }
    this.args.item.save().then(() => {
      this.args?.onSave?.();
    });
  }

  @action
  handleTextDeltaChange(e) {
    this.args.item.text_delta = e;
  }

  @action
  cancelItem() {
    this.args.item.deleteRecord();
    this.args?.onCancel?.();
  }

  @action
  deleteItem() {
    this.args.item.destroyRecord();
  }

  get modules() {
    const modules = {};
    modules.keyboard = {
      bindings: this.keyBindings,
    };
    return modules;
  }

  get keyBindings() {
    const that = this;
    return {
      submit: {
        key: 13, // Enter key code
        shortKey: true, // For cmd key
        handler: function () {
          that.saveItem();
        },
      },
      escape: {
        key: 'Escape',
        handler: function () {
          that.remarks = undefined;
          that.cancelItem();
        },
      },
    };
  }
}
